// Generated from src/img/svg/fullextent.svg

export const Fullextent = (props) => {
  return (
    <svg viewBox="0 0 50 50" {...props}>
      <path
        d="M42 8H26.875l5.75 5.75-5.5 5.5 3.5 3.5 5.5-5.5L42 23.125zM7.063 42.937h15.125l-5.75-5.75 5.5-5.5-3.5-3.5-5.5 5.5-5.875-5.875zM7.063 8v15.125l5.75-5.75 5.5 5.5 3.5-3.5-5.5-5.5L22.188 8zM42 42.937V27.812l-5.75 5.75-5.5-5.5-3.5 3.5 5.5 5.5-5.875 5.875z"
        style={{ fill: "#353535" }}
      />
      <path d="M0 0h50v50H0z" style={{ fill: "none" }} />
    </svg>
  );
};
